<template>
  <div id="statistics">
    <el-tabs type="border-card">
      <el-tab-pane>
        <span slot="label"><i class="el-icon-date" />数据统计</span>

        <div style="margin-bottom: 14px; margin-left: 8px">
          <el-radio v-model="date" label="today">今天</el-radio>
          <el-radio v-model="date" label="yesterday">昨天</el-radio>
          <el-button style="float: right" @click="downloadRepayStatistics">导出数据</el-button>
        </div>

        <!-- total info -->
        <el-card class="box-card user-base-info">
          <el-row>
            <el-col :span="5">累计回收金额：{{ repayStatistics.totalRepayAmount }}</el-col>
            <el-col :span="5">累计回收贷款数：{{ repayStatistics.totalRepayCount }}</el-col>
            <el-col :span="5">处理案件：{{ repayStatistics.collectTaskCount }}</el-col>
            <el-col :span="5">回款率：{{ repayStatistics.collectRate }}</el-col>
          </el-row>
        </el-card>

        <!-- task info -->
        <el-table :data="repayStatisticsLogs" class="statistics-logs" border highlight-current-row
          style="width: 100%">
          <el-table-column prop="borrow_id" label="贷款编号" width="80" />
          <el-table-column prop="user_id" label="用户编号" width="80" />
          <el-table-column prop="user_name" label="借款人" />
          <el-table-column prop="repay_due_time" label="还款到期日" />
          <el-table-column prop="penalty_day" label="逾期天数" width="80" />
          <el-table-column prop="repay_due_amount" label="应还金额" />
          <el-table-column prop="amount" label="实际还款金额" />
          <el-table-column prop="repay_time" label="还款时间" />
          <el-table-column prop="repay_way_name" label="还款方式" />
        </el-table>

        <div class="pagination-section">
          <el-pagination :page-size="pageSize" :total="statisticsTotalCount" layout="prev, pager, next"
            @current-change="changePage" />
        </div>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '../../api.js'

export default {
  name: 'statistics',
  data() {
    return {
      pageSize: 25,
      page: 1,
      date: 'today'
    }
  },
  computed: {
    ...mapGetters([
      'repayStatistics',
      'repayStatisticsLogs'
    ]),
    statisticsTotalCount() {
      return this.repayStatistics.totalRepayCount || 0
    }
  },
  watch: {
    date: function(val, oldVal) {
      this.loadRepayStatistics()
    }
  },
  created() {
    this.loadRepayStatistics()
  },
  methods: {
    ...mapActions([
      'fetchRepayStatistics'
    ]),
    changePage(currentPage) {
      this.page = currentPage
      this.loadRepayStatistics()
    },
    loadRepayStatistics() {
      this.fetchRepayStatistics({ page: this.page, size: this.pageSize, date: this.date })
    },
    downloadRepayStatistics() {
      api.downloadRepayStatistics({ page: this.page, size: this.pageSize, date: this.date })
    }
  }
}
</script>

<style lang="scss">
#statistics {
  .el-card__body {
    padding: 12px 18px;
    font-size: 16px;
  }
}
</style>
